import { InjectionToken } from "@angular/core";

export const INPUT_TEMPLATE_SERVICE = new InjectionToken<string>(
  "INPUT_TEMPLATE_SERVICE"
);
